import AppSettings from './app-settings/AppSettings'
import About from './dialogs/About'
import ToastProvider from './toast/ToastProvider'
import Loader from './Loader'
import Icon from './icon/Icon'

const Common = {
    AppSettings,
    Loader,
    Icon,
    ToastProvider,
    About,
}

export default Common
